import StartRating from "components/StartRating/StartRating";
import React, {FC, useEffect, useState} from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import {generateCancelCode, fetchBookingDetails, priceConvert} from "../../services/bookingPage";
import {toast} from "react-toastify";
import {useHistory, useParams} from "react-router-dom";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import moment from "moment-timezone";
import GallerySlider from "../../components/GallerySlider/GallerySlider";
import {api_url, defaultGalleryImage} from "../../contains/contants";
import StatusBadge from "../Contests/StatusBadge";

export interface PayPageProps {
  className?: string;
}

const PayPage: FC<PayPageProps> = ({ className = "" }) => {

  const params:any = useParams();
  const guid:string = params.guidString;
  const navigate = useHistory();

  const [businessInfo, setBusinessInfo] = useState<any>(undefined);
  const [booking, setBooking] = useState<any>(undefined);
  const [artist, setArtist] = useState<any>(undefined);
  const [service, setService] = useState<any>(undefined);
  const [customer, setCustomer] = useState<any>(undefined);
  const [loading, setLoading] = useState(false)


  useEffect(() => {
    (async () => {
      await setLoading(true)
      let req:any = await fetchBookingDetails(guid);

      if (req.response === "success"){

        await setBusinessInfo(req.businessInfo);
        await setArtist(req.artist);
        await setBooking(req.bookingData);
        await setService(req.service)
        await setCustomer(req.customer)
      }

      await setLoading(false)

    })()

  }, [])

  const bookingStatus = (status: string) => {
    let bgColor = "";
    if (status === "pending"){
      bgColor = "#0000FF"
    }else if(status === "approved"){
      bgColor = "#22c55e"
    }else {
      bgColor = "#EF4444"
    }

    let statusFormat = status.split(/(?=[A-Z])/);

    statusFormat = statusFormat.map(function(word, index) {
      return index === 0 ? word : word.toLowerCase();
    });

    return (<div style={{
      display: "flex",
      justifyContent: "flex-end",
    }}>
      <span style={{backgroundColor: bgColor, color: "white", padding: "5px 10px", borderRadius: 10}}>{statusFormat.join(" ")}</span>
    </div>)
  }

  const renderContent = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">

        {/* ------------------------ */}
        <div className="space-y-6">
          <div style={{
            display: "flex",
            flexDirection: "row"
          }}>
            <div style={{flex: 1}}>
              <h3 className="text-2xl font-semibold">Your booking</h3>
            </div>
            <div style={{flex: 1}}>
              {booking ? bookingStatus(booking.status) : null}
            </div>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="flex-shrink-0 w-full sm:w-40">
              <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
                {booking && booking.images ? <GallerySlider
                    uniqueID={`preview_gallery`}
                    ratioClass="aspect-w-4 aspect-h-3 "
                    galleryImgs={booking.images.length > 0 ? booking.images.map(function (obj:any){return api_url + "/booking/" + booking.bookingId + "/thumbs/" + obj.name}) : [defaultGalleryImage]}
                /> : null}
              </div>
            </div>
            <div className="pt-5  sm:pb-5 sm:px-5 space-y-3">
              <div>
                <span className="text-base sm:text-lg font-medium mt-1 block">
                  {businessInfo ? businessInfo.name : ""}
                </span>
              </div>
              <span className="block  text-sm text-neutral-500 dark:text-neutral-400">
                  {service ? service.serviceName + " " + service.serviceDuration : ""}
              </span>
              <div className="w-10 border-b border-neutral-200  dark:border-neutral-700"></div>
              <StartRating />
            </div>
          </div>
          <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
            <div className="flex-1 p-5 flex space-x-4">
              <svg
                className="w-8 h-8 text-neutral-300 dark:text-neutral-6000"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.33333 8.16667V3.5M18.6667 8.16667V3.5M8.16667 12.8333H19.8333M5.83333 24.5H22.1667C23.4553 24.5 24.5 23.4553 24.5 22.1667V8.16667C24.5 6.878 23.4553 5.83333 22.1667 5.83333H5.83333C4.54467 5.83333 3.5 6.878 3.5 8.16667V22.1667C3.5 23.4553 4.54467 24.5 5.83333 24.5Z"
                  stroke="#D1D5DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <div className="flex flex-col">
                <span className="text-sm text-neutral-400">Date</span>
                <span className="mt-1.5 text-lg font-semibold">
                  {booking ? moment(booking.date).format("DD MMMM YYYY") + " " + booking.hour : null}
                </span>
              </div>
            </div>
            <div className="flex-1 p-5 flex space-x-4">
              <svg
                className="w-8 h-8 text-neutral-300 dark:text-neutral-6000"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 5.07987C14.8551 4.11105 16.1062 3.5 17.5 3.5C20.0773 3.5 22.1667 5.58934 22.1667 8.16667C22.1667 10.744 20.0773 12.8333 17.5 12.8333C16.1062 12.8333 14.8551 12.2223 14 11.2535M17.5 24.5H3.5V23.3333C3.5 19.4673 6.63401 16.3333 10.5 16.3333C14.366 16.3333 17.5 19.4673 17.5 23.3333V24.5ZM17.5 24.5H24.5V23.3333C24.5 19.4673 21.366 16.3333 17.5 16.3333C16.225 16.3333 15.0296 16.6742 14 17.2698M15.1667 8.16667C15.1667 10.744 13.0773 12.8333 10.5 12.8333C7.92267 12.8333 5.83333 10.744 5.83333 8.16667C5.83333 5.58934 7.92267 3.5 10.5 3.5C13.0773 3.5 15.1667 5.58934 15.1667 8.16667Z"
                  stroke="#D1D5DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <div className="flex flex-col">
                <span className="text-sm text-neutral-400">Artist</span>
                <span className="mt-1.5 text-lg font-semibold">{artist ? artist.artistName : ""}</span>
              </div>
            </div>
          </div>
        </div>

        {/* ------------------------ */}
        <div className="space-y-6">
          <h3 className="text-2xl font-semibold">Booking detail</h3>
          <div className="flex flex-col space-y-4">
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Date</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {booking ? moment(booking.date).format("DD MMMM YYYY") + " " + booking.hour : null}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Price</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                 {service ? priceConvert(service.priceType, service.priceValue) : null}
              </span>
            </div>
            {booking ? booking.viewFields.map(function (item:any){
              return (
                  <div key={item.id} className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{item.viewFieldTitle}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                      {item.answer}
                    </span>
                  </div>
              )
            }): null}

          </div>
        </div>
            {/* ------------------------ */}
            <div className="space-y-6">
          <h3 className="text-2xl font-semibold">Your info</h3>
          <div className="flex flex-col space-y-4">
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Your name</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {customer ? customer.fullName : ""}
              </span>
            </div>
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Email address</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {customer ? customer.email : ""}
              </span>
            </div>
            {customer && customer.phone && customer.phone !== 0 ?
                <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                  <span className="flex-1">Telephone</span>
                  <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                 {"+" + customer.telCode.dialCode + " " + customer.phone}
                 </span>
                </div> : null}
          </div>
        </div>
        <div>
          {booking && (booking.status === "pending" || booking.status === "approved") ?  <ButtonPrimary onClick={async () =>{
            let req:any = await generateCancelCode(guid);

            if (req.response === "success"){
              navigate.push("/booking/" + guid + "/cancel");
            }else{
              toast.error("An error occurred. Please refresh and try again", {
                position: toast.POSITION.TOP_CENTER
              });
            }

          }} className={"bg-red-900"}>Cancel Booking</ButtonPrimary> : <ButtonPrimary onClick={() => {
            navigate.push("/studios/" + businessInfo.username + "/book");
          }}>Book Again</ButtonPrimary>}

        </div>
      </div>
    );
  };

  return (
    <div className={`nc-PayPage ${className}`} data-nc-id="PayPage">
      <main className="container mt-11 mb-24 lg:mb-32 ">
        {!loading ? <div className="max-w-4xl mx-auto">{renderContent()}</div> : <LoadingSpinner />}

      </main>
    </div>
  );
};

export default PayPage;
